module.exports = new __parcel__URL__("lion.191125b1.svg").toString();